module.exports = __webpack_public_path__ + "img/inhrportal.42e917f1.svg";